<template>
  <div class="enroll">
    <img src="../../assets/img/enroll-water.png" alt="" />
    <div class="right-mes">
      <img class="logo" src="../../assets/img/home-logo.png" alt="" />
      <p class="title">Freshwater algae database</p>
      <el-form
        :model="loginForm"
        :rules="rules"
        ref="loginForm"
        label-width="32px"
        class="login-form-content"
        hide-required-asterisk
        :show-message="false"
      >
        <el-form-item prop="email">
          <i slot="label" class="icon-label">
            <img
              src="../../assets/img/enroll-mail.png"
              alt=""
              class="email-img"
            />
          </i>
          <el-input
            type="email"
            v-model="loginForm.email"
            autocomplete="off"
            placeholder="Please enter your email"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password" class="password">
          <i slot="label" class="icon-label">
            <img
              src="../../assets/img/enroll-pasw.png"
              alt=""
              class="pasw-img"
            />
          </i>
          <el-input
            ref="passwordInput"
            :type="passwordVisible ? 'text' : 'password'"
            v-model.trim="loginForm.password"
            autocomplete="off"
            placeholder="Please input a password"
            @keyup.enter.native="submitForm('loginForm')"
            suffix-icon="null"
          ></el-input>
          <i
            class="pw-eye"
            :class="
              passwordVisible
                ? 'iconfont icon-xiaoyanjing-zheng'
                : 'iconfont icon-xiaoyanjing-bi'
            "
            @click="passwordVisible = !passwordVisible"
          ></i>
        </el-form-item>
        <p class="no-account">
          <span>No account?</span>
          <router-link class="jump-to-reg" to="/register"
            >Register now</router-link
          >
          <router-link class="jump-to-reg fog-pasw" to="/login/forgetpasw"
            >Forget password</router-link
          >
        </p>
        <el-form-item class="submit-btn">
          <el-button @click="submitForm('loginForm')">Sign in</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import http from '../../utils/http'
import { Message } from 'element-ui'
export default {
  name: 'Enroll',
  data () {
    return {
      loginForm: {
        email: '',
        password: ''
      },
      rules: {
        email: [
          { required: true, trigger: 'blur' },
          { type: 'email', message: ' ', trigger: ['blur'] }
        ],
        password: [{ required: true, trigger: 'blur' }]
      },
      passwordVisible: false
    }
  },
  created () {
    this.$store.commit('toTop')
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // let data = new URLSearchParams()
          // data.append('username', 'gosadmin')
          // data.append('password', 'f97c58cf2555be3958148f59d529242b')
          // data.append(
          //   'captchaVerification',
          //   'sLkNRVNRCVNyxglc3qusQwdREkmuGy3JZJ51q69cQKZyKSyRBwsBpTQpCx5ZrIkS'
          // )
          // this.$axios({
          //   url: '/web/login',
          //   method: 'post',
          //   data,
          //   headers: {
          //     'Content-Type': 'application/x-www-form-urlencoded'
          //   }
          // })
          let { email, password } = this.loginForm
          password = this.$md5(password)
          http.post(
            `/web/login?username=${email}&password=${password}`,
            {},
            res => {
              if (res.code === 200) {
                this.$router.push('/home')
              } else if (res.code === 403) {
                Message.error('Login failed')
              } else {
                Message.error(`${res.msg}`)
              }
            }
          )
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.enroll {
  padding: vw(0) vw(282) vw(0) vw(20);
  display: flex;
  box-sizing: border-box;
  min-width: vw(1200);
  img {
    width: vw(980);
    height: vw(919);
    margin-right: vw(216);
  }
  .right-mes {
    margin-top: vw(160);
    .logo {
      margin-bottom: vw(43);
      width: vw(186);
      height: vw(43);
    }
    .title {
      margin-bottom: vw(60);
      color: #333333;
      font-size: vw(30);
      font-weight: bold;
    }
    .login-form-content {
      .el-form-item {
        border-bottom: 1px solid #dddddd;
        margin: vw(40) 0 0 0;
        >>> .el-form-item__label {
          padding: 0;
          height: 100%;
          .icon-label {
            display: inline-block;
            width: 100%;
            height: 100%;
            position: relative;
            img {
              position: absolute;
              top: 50%;
              left: 0;
              transform: translateY(-75%);
            }
            .email-img {
              width: vw(24);
              height: vw(19);
            }
            .pasw-img {
              width: vw(21);
              height: vw(25);
            }
          }
        }
        >>> .el-form-item__content {
          .el-input {
            .el-input__inner {
              border: none;
              font-size: vw(16);
              padding: 0;
            }
          }
        }
        &.is-error {
          border-bottom: 1px solid red;
        }
        &.password {
          >>> .el-form-item__content {
            position: relative;
            .pw-eye {
              position: absolute;
              top: 0;
              right: 7px;
              cursor: pointer;
              color: #999;
              font-size: vw(16);
            }
          }
        }
      }
      .no-account {
        margin: vw(13) 0 0 0;
        font-size: vw(14);
        color: #999999;
        .jump-to-reg {
          color: $theme_color;
          &:hover {
            color: $theme_color_hover;
          }
        }
        .fog-pasw {
          float: right;
          color: #999;
        }
      }
      .submit-btn {
        border: none;
        margin: vw(80) 0 0 0;
        >>> .el-form-item__content {
          width: 100%;
          margin-left: 0 !important;
          .el-button {
            width: 100%;
            height: vw(60);
            background: $theme_color;
            font-size: vw(22);
            font-weight: 400;
            color: #fbf9fa;
            border-radius: 4px;
            border: none;
            &:focus {
              outline: 0;
            }
            &:hover {
              background: $theme_color_hover;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/enroll/enroll.vue